import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { AuthLoginRequestBody, AuthLoginResponse } from "./types";

export class LoginAPI extends BaseAPI<
    AuthLoginRequestBody,
    AuthLoginResponse
> {
    protected route = ApiRoutes.auth.login;
    protected method = RequestMethod.POST;
}
